const translations = {
  monday: 'Maandag',
  tuesday: 'Dinsdag',
  wednesday: 'Woensdag',
  thursday: 'Donderdag',
  friday: 'Vrijdag',
  saturday: 'Zaterdag',
  sunday: 'Zondag',
};

const translateDay = day => (
  typeof translations[day] !== 'undefined' ? translations[day] : day
);

export default (openingTimes) => {
  const openingTimesLines = Object.keys(openingTimes).map((day) => {
    let times = openingTimes[day].join(', ');

    if (times === '') {
      times = 'gesloten';
    }

    return `
      <tr>
        <td>
          <strong>${translateDay(day)}</strong>
        </td>

        <td>
          ${times}
        </td>
      </tr>
    `;
  }).join('');

  if (!openingTimesLines.length) {
    return '';
  }

  return `
    <strong class="d-block">Openingstijden</strong>

    <table class="mt-1 mb-0">
      ${openingTimesLines}
    </table>
  `;
};
